import { useRef, useLayoutEffect } from 'react';

const getSize = (domNode: HTMLElement) =>
  `${domNode.offsetWidth}x${domNode.offsetHeight}`;

export default function useResize(
  domNode: HTMLElement | TNil,
  onResize: (domNode: HTMLElement) => unknown
) {
  const ref = useRef('');

  const callback = useRef(onResize);
  callback.current = onResize;

  useLayoutEffect(() => {
    if (!domNode) return;

    const observer = new ResizeObserver(() => {
      const size = getSize(domNode);
      if (size !== ref.current) {
        ref.current = size;
        callback.current(domNode);
      }
    });

    observer.observe(domNode);
    return () => observer.disconnect();
  }, [domNode]);
}
